import React from "react";
import { UshqimForm } from "@/components/UshqimForm";
import { REKLAME_SUBS } from "@/lib/categories";
import { REKLAME_COUNTRIES, reklameCitiesMap } from "@/lib/places";

// Reklamë reuses the full UshqimForm system (photo, logo, orar, shërbime, pagesa, social, hartë)
export function ReklameForm({ onDone, initial }) {
  return (
    <UshqimForm
      onDone={onDone}
      initial={initial}
      catKey="reklame"
      heading="Reklamë"
      subtitle="Publiko reklamën tënde — vetëm 🇽🇰 🇦🇱 🇲🇰 🇲🇪"
      subs={REKLAME_SUBS}
      countries={REKLAME_COUNTRIES}
      citiesMap={reklameCitiesMap()}
      phoneCodes={REKLAME_COUNTRIES.map((c) => ({ flag: c.flag, dial: c.dial }))}
      rules={true}
    />
  );
}

export default ReklameForm;
